export default "__VITE_ASSET__b6fe6362__"